module.exports = __webpack_public_path__ + "img/client_logo_4.0f7f9bff.png";